import { render, staticRenderFns } from "./FeaturedProcessesSection.vue?vue&type=template&id=52d26418&scoped=true"
import script from "./FeaturedProcessesSection.vue?vue&type=script&lang=js"
export * from "./FeaturedProcessesSection.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProcessesSection.vue?vue&type=style&index=0&id=52d26418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d26418",
  null
  
)

export default component.exports